import { Loader2 } from 'lucide-react';
import { SkeletonBar, SkeletonCard } from './SkeletonCard';

/**
 * Индикатор загрузки данных аналитики (просьба владельца 13.08.2026, tvr1):
 * вращающийся маркер + подпись + шиммер-скелетоны, чтобы «грузится» никогда
 * не выглядело как «зависло» — особенно на мобильном.
 */
export function DataLoading({ label = 'Считаю данные…', cards = 2 }: { label?: string; cards?: number }) {
  return (
    <div className="flex flex-col gap-3" role="status" aria-live="polite">
      <div className="flex items-center gap-2 text-ops-caption text-ops-text-secondary">
        <Loader2 className="h-4 w-4 animate-spin text-ops-primary" />
        {label}
      </div>
      <SkeletonBar className="h-8 w-2/3" />
      {Array.from({ length: cards }, (_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
